const services = {
  fr: [
    { key: "marketing", label: "Marketing continu", intro: "Une présence qui grandit chaque mois, pilotée par la donnée et l'intuition.",
      items: [
        { slug: "seo", name: "SEO", desc: "Référencement naturel, contenus et autorité — pour être trouvé sur Google comme dans les réponses IA." },
        { slug: "paid-media", name: "Publicité & PPC", desc: "Google Ads, Meta, LinkedIn. Des campagnes sobres, précises, mesurées au centime." },
        { slug: "social-video", name: "Réseaux sociaux & vidéo", desc: "Ligne éditoriale, production vidéo et community management pour les marques désirables." },
        { slug: "email-marketing", name: "Email marketing", desc: "Newsletters, automations et réactivation de bases — l'élégance dans chaque envoi." },
      ] },
    { key: "web", label: "Sites web", intro: "Des expériences digitales pensées comme des flagships.",
      items: [
        { slug: "web-design", name: "Design & développement web", desc: "Sites vitrines, e-commerce et plateformes sur mesure, rapides et bilingues." },
        { slug: "maintenance", name: "Maintenance & support", desc: "Sécurité, mises à jour, performance et évolutions continues." },
        { slug: "inbound-crm", name: "Inbound & CRM", desc: "HubSpot, automatisations et tunnels de conversion connectés à vos ventes." },
      ] },
    { key: "brand", label: "Marque", intro: "L'identité comme un parfum : immédiatement reconnaissable.",
      items: [
        { slug: "brand-identity", name: "Identité de marque", desc: "Plateforme, nom, logo, univers visuel et guidelines." },
        { slug: "graphic-design", name: "Design graphique", desc: "Print, packaging, éditions et supports de campagne." },
        { slug: "content-creation", name: "Création de contenu", desc: "Direction artistique, photo, copywriting et storytelling." },
      ] },
  ],
  en: [
    { key: "marketing", label: "Ongoing marketing", intro: "A presence that grows every month, driven by data and intuition.",
      items: [
        { slug: "seo", name: "SEO", desc: "Search, content and authority — to be found on Google and in AI answers alike." },
        { slug: "paid-media", name: "Paid media & PPC", desc: "Google Ads, Meta, LinkedIn. Restrained, precise campaigns measured to the cent." },
        { slug: "social-video", name: "Social media & video", desc: "Editorial lines, video production and community management for desirable brands." },
        { slug: "email-marketing", name: "Email marketing", desc: "Newsletters, automations and list reactivation — elegance in every send." },
      ] },
    { key: "web", label: "Websites", intro: "Digital experiences designed like flagship stores.",
      items: [
        { slug: "web-design", name: "Web design & development", desc: "Showcase sites, e-commerce and bespoke platforms, fast and bilingual." },
        { slug: "maintenance", name: "Maintenance & support", desc: "Security, updates, performance and continuous improvements." },
        { slug: "inbound-crm", name: "Inbound & CRM", desc: "HubSpot, automations and conversion funnels wired to your sales." },
      ] },
    { key: "brand", label: "Brand", intro: "Identity like a fragrance: instantly recognisable.",
      items: [
        { slug: "brand-identity", name: "Brand identity", desc: "Platform, naming, logo, visual universe and guidelines." },
        { slug: "graphic-design", name: "Graphic design", desc: "Print, packaging, editions and campaign assets." },
        { slug: "content-creation", name: "Content creation", desc: "Art direction, photography, copywriting and storytelling." },
      ] },
  ],
};

const work = {
  fr: [
    { id: "w1", title: "Maison Verre", cat: "Identité & site e-commerce", city: "Paris", img: "/img/model.jpg", desc: "Refonte d'identité et boutique en ligne pour une marque de prêt-à-porter. Projet d'exemple à remplacer par votre propre étude de cas." },
    { id: "w2", title: "Lac & Pierre", cat: "Branding hôtelier", city: "Genève", img: "/img/interior.jpg", desc: "Univers de marque et site de réservation pour une adresse hôtelière. Projet d'exemple à remplacer." },
    { id: "w4", title: "Studio Nord", cat: "Social & vidéo", city: "Londres", img: "/img/suit.jpg", desc: "Production vidéo et stratégie social media pour un label créatif. Projet d'exemple à remplacer." },
  ],
  en: [
    { id: "w1", title: "Maison Verre", cat: "Identity & e-commerce", city: "Paris", img: "/img/model.jpg", desc: "Identity refresh and online store for a ready-to-wear label. Sample project to replace with your own case study." },
    { id: "w2", title: "Lac & Pierre", cat: "Hospitality branding", city: "Geneva", img: "/img/interior.jpg", desc: "Brand universe and booking site for a hospitality address. Sample project to replace." },
    { id: "w4", title: "Studio Nord", cat: "Social & video", city: "London", img: "/img/suit.jpg", desc: "Video production and social strategy for a creative label. Sample project to replace." },
  ],
};

export const dict = {
  fr: {
    nav: { services: "Expertises", work: "Réalisations", approach: "Méthode", houses: "Maisons", journal: "Journal", contact: "Contact", cta: "Démarrer un projet" },
    hero: {
      over: "Agence de marketing digital — Genève · Paris · Londres",
      lines: ["Une maison", "d'idées pour", "les marques désirables."],
      sub: "Stratégie, création et média réunis sous un même toit. Nous imaginons des marques, des sites et des campagnes qui se remarquent — et qui performent.",
      cta: "Démarrer un projet", cta2: "Voir les réalisations", scroll: "Défiler",
    },
    marquee: ["Genève", "Paris", "Londres", "Strategy", "Creative", "Media", "A House of Ideas"],
    services: { over: "01 — Expertises", title: "Toutes les disciplines,", title2: "une seule signature.", sub: "Tout ce dont une marque a besoin pour exister en ligne, réuni dans une maison.", discover: "Découvrir" },
    work: { over: "02 — Réalisations", title: "Le travail", title2: "parle de lui-même.", badge: "Exemple — à remplacer", view: "Voir le projet", close: "Fermer", items: work.fr },
    approach: {
      over: "03 — Méthode", title: "Du brief", title2: "à la croissance.",
      steps: [
        { n: "I", t: "Écouter", d: "Atelier de découverte, audit de marque, analyse de marché et de concurrence." },
        { n: "II", t: "Imaginer", d: "Plateforme stratégique, direction artistique et plan média sur mesure." },
        { n: "III", t: "Créer", d: "Design, développement, production de contenus — avec une exigence d'atelier." },
        { n: "IV", t: "Faire grandir", d: "Pilotage mensuel, tests, reporting clair et optimisation continue." },
      ],
    },
    houses: {
      over: "04 — Nos maisons", title: "Trois villes,", title2: "un même regard.",
      list: [
        { city: "Genève", role: "Stratégie & précision", img: "/img/geneva.jpg", coord: "46.2044° N, 6.1432° E" },
        { city: "Paris", role: "Création & image", img: "/img/paris.jpg", coord: "48.8566° N, 2.3522° E" },
        { city: "Londres", role: "Média & performance", img: "/img/london.jpg", coord: "51.5072° N, 0.1276° W" },
      ],
    },
    journal: {
      over: "05 — Journal", title: "Idées & perspectives.", badge: "Article d'exemple",
      posts: [
        { t: "SEO à l'ère de l'IA : comment rester visible", c: "Stratégie" },
        { t: "Pourquoi les marques premium arrêtent de « booster » leurs posts", c: "Média" },
        { t: "Sept signes qu'il est temps de refondre votre site", c: "Web" },
      ],
    },
    contact: {
      over: "06 — Contact", title: "Parlons de", title2: "votre maison.",
      sub: "Racontez-nous votre projet. Nous revenons vers vous sous 48 heures ouvrées.",
      name: "Nom complet", email: "Email", company: "Société", service: "Expertise souhaitée", budget: "Budget", city: "Bureau", message: "Votre projet",
      choose: "Choisir", any: "Peu importe",
      budgets: ["< 5 000 €", "5 000 – 15 000 €", "15 000 – 50 000 €", "> 50 000 €"],
      send: "Envoyer la demande", sending: "Envoi…", ok: "Merci — votre demande a bien été reçue.", err: "Une erreur est survenue. Réessayez.",
      required: "Merci de remplir nom, email et projet.",
    },
    footer: { tag: "Strategy · Creative · Media", rights: "Tous droits réservés.", admin: "Espace admin", placeholder: "Coordonnées à compléter", services: "Expertises", legal: "Mentions légales", privacy: "Confidentialité", cookies: "Cookies", brand: "Kit de marque" },
    cookies: { over: "Cookies", title: "Un peu de mesure, avec votre accord.", body: "Nous utilisons un outil de mesure d'audience pour comprendre comment le site est consulté. Aucune donnée n'est collectée sans votre consentement.", more: "En savoir plus", accept: "Accepter", refuse: "Refuser" },
    services_data: services.fr,
    seo: {
      homeTitle: "Agence marketing digital premium — Genève, Paris, Londres | ALLURE HOUSE",
      homeDescription: "ALLURE HOUSE — agence de marketing digital à Genève, Paris et Londres. Stratégie, création et média : SEO, publicité, sites web, branding, réseaux sociaux, email.",
    },
  },
  en: {
    nav: { services: "Expertise", work: "Work", approach: "Method", houses: "Houses", journal: "Journal", contact: "Contact", cta: "Start a project" },
    hero: {
      over: "Digital marketing agency — Geneva · Paris · London",
      lines: ["A house", "of ideas for", "desirable brands."],
      sub: "Strategy, creative and media under one roof. We craft brands, websites and campaigns that get noticed — and perform.",
      cta: "Start a project", cta2: "See the work", scroll: "Scroll",
    },
    marquee: ["Geneva", "Paris", "London", "Strategy", "Creative", "Media", "A House of Ideas"],
    services: { over: "01 — Expertise", title: "Every discipline,", title2: "one signature.", sub: "Everything a brand needs to exist online, gathered in one house.", discover: "Discover" },
    work: { over: "02 — Work", title: "The work", title2: "speaks for itself.", badge: "Sample — to replace", view: "View project", close: "Close", items: work.en },
    approach: {
      over: "03 — Method", title: "From brief", title2: "to growth.",
      steps: [
        { n: "I", t: "Listen", d: "Discovery workshop, brand audit, market and competitor analysis." },
        { n: "II", t: "Imagine", d: "Strategic platform, art direction and a bespoke media plan." },
        { n: "III", t: "Craft", d: "Design, development and content production — with atelier standards." },
        { n: "IV", t: "Grow", d: "Monthly steering, testing, clear reporting and continuous optimisation." },
      ],
    },
    houses: {
      over: "04 — Our houses", title: "Three cities,", title2: "one eye.",
      list: [
        { city: "Geneva", role: "Strategy & precision", img: "/img/geneva.jpg", coord: "46.2044° N, 6.1432° E" },
        { city: "Paris", role: "Creative & image", img: "/img/paris.jpg", coord: "48.8566° N, 2.3522° E" },
        { city: "London", role: "Media & performance", img: "/img/london.jpg", coord: "51.5072° N, 0.1276° W" },
      ],
    },
    journal: {
      over: "05 — Journal", title: "Ideas & perspectives.", badge: "Sample article",
      posts: [
        { t: "SEO in the age of AI: how to stay visible", c: "Strategy" },
        { t: "Why premium brands stop boosting their posts", c: "Media" },
        { t: "Seven signs it's time to redesign your website", c: "Web" },
      ],
    },
    contact: {
      over: "06 — Contact", title: "Let's talk about", title2: "your house.",
      sub: "Tell us about your project. We'll get back to you within 48 business hours.",
      name: "Full name", email: "Email", company: "Company", service: "Expertise needed", budget: "Budget", city: "Office", message: "Your project",
      choose: "Select", any: "Any",
      budgets: ["< €5,000", "€5,000 – 15,000", "€15,000 – 50,000", "> €50,000"],
      send: "Send enquiry", sending: "Sending…", ok: "Thank you — your enquiry has been received.", err: "Something went wrong. Please retry.",
      required: "Please fill in name, email and project.",
    },
    footer: { tag: "Strategy · Creative · Media", rights: "All rights reserved.", admin: "Admin", placeholder: "Contact details to complete", services: "Expertise", legal: "Legal notice", privacy: "Privacy", cookies: "Cookies", brand: "Brand kit" },
    cookies: { over: "Cookies", title: "A little measurement, with your consent.", body: "We use an audience measurement tool to understand how the site is browsed. No data is collected without your consent.", more: "Learn more", accept: "Accept", refuse: "Refuse" },
    services_data: services.en,
    seo: {
      homeTitle: "Premium digital marketing agency — Geneva, Paris, London | ALLURE HOUSE",
      homeDescription: "ALLURE HOUSE — digital marketing agency in Geneva, Paris and London. Strategy, creative and media: SEO, advertising, websites, branding, social media, email.",
    },
  },
};
